<script>
  import Search from "./Search.svelte";
  import ShoppingBag from "./ShoppingBag.svelte";
  import User from "./User.svelte";
</script>

<div class="icons-container">
  <Search />
  <User />
  <ShoppingBag />
</div>

<style>
  .icons-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 1rem;
  }
  @media (max-width: 1024px) {
    .icons-container {
      gap: 0.5rem;
    }
  }
  @media (max-width: 820px) {
    .icons-container {
      width: 100%;
      gap: 1rem;
    }
  }
</style>
